<template>
  <div class="body">
    <el-card class="card" shadow="never">
      <div class="header">
        <h3>下载中心</h3>
      </div>

      <div class="main">
        <el-row :gutter="30" class="table">
          <el-col :span="12">
            <el-table
                :cell-style="{padding:'0px'}"
                :data="tableData1"
                :header-cell-style="setSellStyle"
                :row-style="{height:'64px',color:'#333333'}"
                stripe
                style="width: 100%">
              <el-table-column
                  label="文件名称"
                  prop="name"
                  show-overflow-tooltip
                  width="400">
              </el-table-column>
              <el-table-column
                  label="大小">
                <template slot-scope="scope">
                  <p>{{ scope.row.size }}Mb</p>
                </template>
              </el-table-column>
              <el-table-column
                  label="上传时间"
                  prop="date">
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-link type="primary">下载</el-link>
                </template>
              </el-table-column>
            </el-table>
          </el-col>

          <el-col :span="12">
            <el-table
                :cell-style="{padding:'0px'}"
                :data="tableData2"
                :header-cell-style="setSellStyle"
                :row-style="{height:'64px',color:'#333333'}"
                stripe
                style="width: 100%">
              <el-table-column
                  label="文件名称"
                  prop="name"
                  show-overflow-tooltip
                  width="400">
              </el-table-column>
              <el-table-column
                  label="大小">
                <template slot-scope="scope">
                  <p>{{ scope.row.size }}Mb</p>
                </template>
              </el-table-column>
              <el-table-column
                  label="上传时间"
                  prop="date">
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-link type="primary">下载</el-link>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "Download",
  created() {
    this.init();
  },
  data() {
    return {
      downloadData: [{
        date: '2016-05-02',
        name: '1关于在上海举办矿业2020年中国国际矿业关于在上海举办矿业2020年中国国际矿业',
        size: '3.2'
      }, {
        date: '2016-05-02',
        name: '2参展商书册',
        size: '3.2'
      }, {
        date: '2016-05-02',
        name: '3参展商书册',
        size: '3.2'
      }, {
        date: '2016-05-02',
        name: '4关于在上海举办矿业2020年中国国际矿业关于在上海举办矿业2020年中国国际矿业',
        size: '3.2'
      }, {
        date: '2016-05-02',
        name: '5关于在上海举办矿业2020年中国国际矿业关于在上海举办矿业2020年中国国际矿业',
        size: '3.2'
      }, {
        date: '2016-05-02',
        name: '6关于在上海举办矿业2020年中国国际矿业关于在上海举办矿业2020年中国国际矿业',
        size: '3.2'
      }, {
        date: '2016-05-02',
        name: '7关于在上海举办矿业2020年中国国际矿业关于在上海举办矿业2020年中国国际矿业',
        size: '3.2'
      }],

      tableData1: [],
      tableData2: [],
    }
  },

  methods: {
    //分割数据
    splitData() {
      this.downloadData.forEach((item, index) => {
        if (index % 2) {
          this.tableData2.push(item)
        } else {
          this.tableData1.push(item)
        }
      })
    },

    //表头圆角处理
    setSellStyle({row, column, rowIndex, columnIndex}) {
      if (column.label === '文件名称') {
        return "background:#FDC400;color:#FFF;border-top-left-radius:5px;font-weight: 500;height: 42px;padding: 0;"
      }
      if (column.label === '操作') {
        return "background:#FDC400;color:#FFF;border-top-right-radius:5px;font-weight: 500;height: 42px;padding: 0;"
      } else {
        return "background:#FDC400;color:#FFF;font-weight: 500;height: 42px;padding: 0;"
      }
    },

    init() {
      this.splitData();
    }
  }

}
</script>

<style lang='scss' scoped>
.body {
  margin: 20px 30px 0 30px;
  font-family: PingFangSC-Medium, PingFang SC;

  .header {
    padding: 0 0 20px 30px;
    border-bottom: 1px solid #E8E8E8;

    h3 {
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      line-height: 28px;
    }
  }

  .main {
    //border: 1px solid red;
    margin: 40px 30px 0;
  }
}
</style>

<style scoped>
>>> .el-card__body {
  padding: 20px 0;
  height: 500px
}
>>> .el-table {
  font-size: 16px;
  font-weight: 500;
}
</style>
